import { Check } from "lucide-react";
import { SectionEyebrow } from "@/components/ui/SectionEyebrow";
import { RedirectNotice } from "@/components/ui/RedirectNotice";
import Link from "@/components/ui/RouterLink";
import { emailPlan } from "@/data/products";

const features = [
  "30 GB mailbox storage",
  "Advanced email features",
  "Professional email identity",
  "Access across supported devices",
  "Organised business communication",
];

export function EmailFeature() {
  return (
    <section className="relative overflow-hidden border-y border-border bg-gradient-to-br from-navy-secondary to-navy py-20">
      <div
        className="absolute -bottom-32 right-1/4 h-[420px] w-[420px] rounded-full bg-primary/20 blur-[130px]"
        aria-hidden="true"
      />
      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-5 lg:grid-cols-2 lg:px-8">
        <div>
          <SectionEyebrow>Professional Business Email</SectionEyebrow>
          <h2 className="mt-5 font-display text-3xl font-semibold text-text-primary sm:text-4xl">
            Your Business Deserves More Than a Basic Inbox
          </h2>
          <p className="mt-5 max-w-lg text-sm leading-relaxed text-text-secondary">
            Communicate using a professional business email solution with a 30 GB mailbox and
            advanced features created for everyday business communication.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <RedirectNotice
              href={emailPlan.buyNowUrl}
              eventPayload={{ product: "email" }}
              className="focus-ring inline-flex items-center justify-center gap-2 rounded-full bg-gradient-brand px-6 py-3 text-sm font-medium text-white transition hover:brightness-110"
            >
              View Email Solution
            </RedirectNotice>
            <Link
              href="/contact"
              className="focus-ring inline-flex items-center justify-center gap-2 rounded-full border border-border px-6 py-3 text-sm font-medium text-text-primary transition hover:border-cyan/50"
            >
              Talk to Sales
            </Link>
          </div>
        </div>

        <div className="glass-panel rounded-card p-8">
          <p className="text-xs font-medium uppercase tracking-wide text-text-muted">
            {emailPlan.name}
          </p>
          <p className="mt-2 font-display text-4xl font-semibold text-text-primary">
            Starting at {emailPlan.price}
          </p>
          <p className="mt-1 text-xs text-text-muted">
            Billing period to be confirmed in the final catalogue.
          </p>

          <ul className="mt-6 space-y-3 border-t border-border pt-6">
            {features.map((f) => (
              <li key={f} className="flex items-start gap-2.5 text-sm text-text-secondary">
                <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-status-success" />
                {f}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
